module.exports = __webpack_public_path__ + "img/2.4f3735c5.jpg";